<template>
    <Layout class="customers-page" is-crm>
        <header class="page__top customers-page__header">
            <h1 v-t="'crm.customers.title'"></h1>
            <div class="customers-page__toolbar">
                <WithGlobalPermission permission="Customer.create">
                    <router-link
                        :to="{ name: 'customers-create' }"
                        class="button button--big customers-page__create-trigger"
                    >
                        <IconUser class="icon" />
                        <span v-t="'crm.customers.create.trigger'" />
                    </router-link>
                </WithGlobalPermission>
            </div>
        </header>
        <PaginatedResource
            ref="customersResource"
            :fetch-method="fetchCustomers"
            :sorting-fields="sortingFields"
            filter-key="customers"
        >
            <template
                #default="{
                    loading,
                    sort,
                    canLoadMore,
                    resource: customers,
                    isEmpty,
                    notFound,
                    loadMore,
                }"
            >
                <div class="customers">
                    <Spinner v-if="loading" />
                    <CustomersTable
                        v-if="!isEmpty"
                        class="customers-page__table"
                        :customers="customers"
                        :sorting-fields="sortingFields"
                        @sort="sort"
                    />
                    <div v-if="notFound" class="empty">
                        {{ $t('crm.customers.list.notFound') }}
                    </div>
                    <div v-if="isEmpty" class="empty">
                        {{ $t('crm.customers.list.empty') }}
                    </div>
                    <div v-if="canLoadMore" class="customers-page__loadmore">
                        <button
                            class="button button--big button--blank"
                            type="button"
                            @click="loadMore"
                        >
                            {{ $t('misc.loadmore') }}
                        </button>
                    </div>
                </div>
            </template>
        </PaginatedResource>
    </Layout>
</template>

<script>
import { fetchCustomers } from '../../api/customers';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import PaginatedResource from '@speechki-frontend/shared/PaginatedResource';
import CustomersTable from '../../components/CustomersTable/CustomersTable';
import { IconUser } from '@speechki-frontend/shared/ui/icons';
import { WithGlobalPermission } from '@speechki-frontend/core/auth/components';

export default {
    name: 'CustomersPage',
    components: {
        Layout,
        Spinner,
        PaginatedResource,
        CustomersTable,
        IconUser,
        WithGlobalPermission,
    },
    data() {
        return {
            sortingFields: ['id', 'name'],
        };
    },
    watch: {
        '$route.query.sort': {
            async handler(value) {
                if (value === undefined) return;
                await this.$nextTick();
                this.$refs.customersResource.sort(value);
            },
            immediate: true,
        },
    },
    methods: {
        fetchCustomers,
    },
};
</script>

<style lang="scss" src="./CustomersPage.scss"></style>
